import {
	useRef, useState, useEffect
} from 'react';

function Timer(props) {
	const { mode = 'timer', daysLeft = 0 } = props;
	const timerRef = useRef(null);
	const [countdown, setCountdown] = useState('00:00:00');

	const pad = (n) => n.toString().padStart(2, '0');

	const startTimer = () => {
		if (timerRef.current) {
			clearInterval(timerRef.current);
		}
		if (mode === 'timer') {
			timerRef.current = setInterval(() => {
				const currentNow = new Date();
				const currentTargetTime = new Date();
				currentTargetTime.setHours(0, 0, 0, 0);
				currentTargetTime.setDate(currentTargetTime.getDate() + 1);

				const currentTimeDiff = currentTargetTime.getTime() - currentNow.getTime();

				if (currentTimeDiff <= 0) {
					setCountdown('00:00:00');
					clearInterval(timerRef.current);
					return;
				}

				const currentHours = Math.floor(currentTimeDiff / (1000 * 60 * 60));
				const currentMinutes = Math.floor((currentTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
				const currentSeconds = Math.floor((currentTimeDiff % (1000 * 60)) / 1000);

				const updatedCountdown = `${pad(currentHours)}:${pad(currentMinutes)}:${pad(currentSeconds)}`;
				setCountdown(updatedCountdown);
			}, 1000);
		} else if (mode === 'days') {
			const currentDate = new Date().getDate();
			if (currentDate <= daysLeft) {
				const differenceInDays = daysLeft - currentDate;
				if (differenceInDays === 0) {
					timerRef.current = setInterval(() => {
						const currentNow = new Date();
						const currentTargetTime = new Date();
						currentTargetTime.setHours(0, 0, 0, 0);
						currentTargetTime.setDate(currentTargetTime.getDate() + 1);

						const currentTimeDiff = currentTargetTime.getTime() - currentNow.getTime();

						if (currentTimeDiff <= 0) {
							setCountdown('00:00:00');
							clearInterval(timerRef.current);
							return;
						}

						const currentHours = Math.floor(currentTimeDiff / (1000 * 60 * 60));
						const currentMinutes = Math.floor((currentTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
						const currentSeconds = Math.floor((currentTimeDiff % (1000 * 60)) / 1000);

						const updatedCountdown = `${pad(currentHours)}:${pad(currentMinutes)}:${pad(currentSeconds)}`;
						setCountdown(updatedCountdown);
					}, 1000);
				} else {
					setCountdown(`${differenceInDays} ${differenceInDays === 1 ? 'day' : 'days'} left`);
				}
			} else if (currentDate > daysLeft) {
				setCountdown('No more days left');
			}
		}
	};

	useEffect(() => {
		startTimer();
		return () => {
			if (timerRef.current) {
				clearInterval(timerRef.current);
			}
		};
	}, []);

	return <span className='text-[12px] text-orange-500 text-nowrap'>{countdown}</span>;
}

export default Timer;
